import { NgModule } from '@angular/core';
import { FromDatePipe } from '@shared/pipes/from-date.pipe';

@NgModule({
  exports: [FromDatePipe],
  declarations: [FromDatePipe],
})
export class FromDateModule {}
